/**
 * Web stub for `expo-iap`.
 *
 * `expo-iap` has no web implementation, so the web bundle must never reach the
 * real module.
 *
 * `ErrorCode` is re-exported from `expo-iap/build/types`, a dependency-free
 * enum file, so error-code comparisons keep working on web.
 */
import { Linking } from 'react-native';
export { ErrorCode } from 'expo-iap/build/types';
const noopSubscription = { remove: () => { } };
export const purchaseUpdatedListener = (() => noopSubscription);
export const purchaseErrorListener = (() => noopSubscription);
export const promotedProductListenerIOS = (() => noopSubscription);
export const initConnection = (async () => false);
export const endConnection = (async () => false);
export const fetchProducts = (async () => []);
export const getAvailablePurchases = (async () => []);
export const getActiveSubscriptions = (async () => []);
export const getPromotedProductIOS = (async () => null);
export const getReceiptDataIOS = (async () => '');
export const requestReceiptRefreshIOS = (async () => '');
export const isEligibleForIntroOfferIOS = (async () => false);
export const finishTransaction = (async () => false);
const unavailableOnWeb = (name) => async () => {
    throw new Error(`expo-iap: ${name} is not available on web`);
};
export const requestPurchase = unavailableOnWeb('requestPurchase');
export const showManageSubscriptionsIOS = unavailableOnWeb('showManageSubscriptionsIOS');
/**
 * The only entry point genuinely reachable on web (from
 * `useOpenManageAppStoreSubscription`), so it gets a real implementation.
 */
export const deepLinkToSubscriptions = (async (options) => {
    if (options?.packageNameAndroid) {
        await Linking.openURL(`https://play.google.com/store/account/subscriptions?package=${options.packageNameAndroid}&sku=${options.skuAndroid || ''}`);
        return;
    }
    await Linking.openURL('https://apps.apple.com/account/subscriptions');
});
